import React from 'react';
import { Icons } from '@casanova/casanova-common';
import DropFile from '../DropFile';
import styles from './styles.module.css';

export default function StepOne({
  excelFile,
  handleExcelFile
}) {
  return (
    <>
      <div className="row mt-2">
        <div className="col-md-12">
          <h5>Archivo de excel</h5>
          <DropFile
            accept=".xls,.xlsx"
            height="96px"
            onDropFile={handleExcelFile}
            files={excelFile}
            icon={(hasFile) => (
              <div className={styles.iconMd}>
                <Icons.FileCombined fill={hasFile ? '#8e8e93' : '#f2a000'} />
              </div>
            )}
          />
        </div>
      </div>
    </>
  );
}
